import punch from './punch';
export default punch;
